<template>
  <div>
    <div class="card mb-3 d-print-none">
      <div class="card-body chart">
        <div class="row">
          <div class="col">
            <label for="lastNameFilter" class="form-label">Teacher Last Name:</label>
            <input id="lastNameFilter" v-model="lastNameFilter" class="form-control" type="text" placeholder="Enter last name">
          </div>
          <div class="col">
            <label for="firstNameFilter" class="form-label">Teacher First Name:</label>
            <input id="firstNameFilter" v-model="firstNameFilter" class="form-control" type="text" placeholder="Enter first name">
          </div>
        </div>
        <!-- <div class="row mt-2">
          <div class="col">
            <label for="topQuartileFilter" class="form-label mr-1">Top Quartile for Growth</label>
            <custom-tooltip
              content="A.C.A § 6-17-431 and A.C.A § 6-17-429 reference assigning students who have not met readiness standards to a teacher with a three-year growth score in the top quartile for ELA or Math. Refer to the Rules Governing Math Intervention and the Right to Read Rules for more information."
              :element-id="topQuartileFilter" />
            <select id="topQuartileFilter" v-model="topQuartileFilter" class="form-control">
              <option value="All">
                All
              </option>
              <option value="true">
                Yes
              </option>
              <option value="false">
                No
              </option>
            </select>
          </div>
        </div> -->
      </div>
    </div>
    <paginated-table :items="teachers" :fields="fields" sort-by="lastName" :sort-desc="false">
      <template v-slot:cell(districtLEA)="data">
        <div>
          <button type="button" class="btn btn-link" @click="goToLea(data.value)" :id="data.index + '-' + data.value">
            {{ leaFormatter(data.value) }}
          </button>
          <lea-tooltip :target-selector="data.index + '-' + data.value" :lea-number="data.value" />
        </div>
      </template>
      <template v-slot:cell(caseId)="data">
        <aels-case-id-link :case-id="data.value" />
      </template>
      <template v-slot:cell(schoolLEA)="data">
        <div>
          <button type="button" class="btn btn-link" @click="goToLea(data.value)" :id="data.index + '-' + data.value">
            {{ leaFormatter(data.value) }}
          </button>
          <lea-tooltip :target-selector="data.index + '-' + data.value" :lea-number="data.value" />
        </div>
      </template>
      <template v-slot:cell(teacherLastName)="data" class=".chart">
        {{ data.value }}
      </template>
      <template v-slot:cell(teacherFirstName)="data">
        {{ data.value }}
      </template>
      <template v-slot:cell(role)="data">
        {{ data.value }}
      </template>
      <template v-slot:cell(growthScoreFY_2)="data">
        {{ data.value ? data.value.toFixed(2) : '' }}
      </template>
      <template v-slot:cell(growthScoreFY_1)="data">
        {{ data.value ? data.value.toFixed(2) : '' }}
      </template>
      <template v-slot:cell(growthScoreFY)="data">
        {{ data.value ? data.value.toFixed(2) : '' }}
      </template>
      <template v-slot:cell(threeYearAverageGrowthScore)="data">
        <strong>{{ data.value ? data.value.toFixed(2) : '' }}</strong>
      </template>
      <template v-slot:cell(topQuartileForGrowth)="data">
        <div>
          <i v-if="data.value" class="fa-lg fas fa-check text-success" />
          <span v-else-if="subject === 'Composite'">N/A</span>
        </div>
      </template>
      <template v-slot:head(meetsDefinitionOfTeacher)="data">
        <custom-tooltip
          content="Per A.C.A 6-17-2902, Teacher means a licensed classroom teacher who spends at least 70% of his or her contracted time working directly with students in a classroom setting teaching all grade-level or subject-matter appropriate classes. Teacher also includes library media specialists and guidance counselors. Individuals on this list teach a course or hold a job code that aligns with this definition."
          :element-id="`meetsDefinitionOfTeacher-${data.label}`"
          :label="data.label"
        />
      </template>
      <template v-slot:head(noIntensiveSupport)="data">
        <custom-tooltip
          content="A.C.A. § 6-17-2904 prohibits anyone given intensive support status under TESS from receiving funds under the merit pay program for the school year in which the status is given."
          :element-id="`noIntensiveSupport-${data.label}`"
          :label="data.label"
        />
      </template>
      <template v-slot:cell(tessRating)="data">
        <span>{{ data.value }}</span>
      </template>
      <template v-slot:cell(threeYearCompositeGrowthScore)="data">
        <span>{{ data.value != null ? data.value.toFixed(2) : '' }}</span>
      </template>
      <template v-slot:cell(positiveImpactOnStudentGrowth)="data">
        <div class="d-inline">
          <span class="fa fa-check-circle" :class="{'text-success': data.value, 'text-secondary': !data.value}" />
        </div>
      </template>
      <template v-slot:cell(outstandingGrowthBonus)="data">
        <span>{{ data.value && data.value !== 0 ? data.value.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : '' }}</span>
      </template>
      <template v-slot:cell(overallShortageAreaBonus)="data">
        <span>{{ data.value && data.value !== 0 ? data.value.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : '' }}</span>
      </template>
      <template v-slot:cell(mentorBonus)="data">
        <span>{{ data.value && data.value !== 0 ? data.value.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : '' }}</span>
      </template>
      <template v-slot:cell(totalBonus)="data">
        <span>{{ data.value && data.value !== 0 ? data.value.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : '' }}</span>
      </template>
      <template v-slot:cell(meetsDefinitionOfTeacher)="data">
        <b-form-checkbox
          v-if="!isCertified"
          :checked="data.value"
          switch
          @change="onMeetsDefinitionToggle(data.item, $event)"
          :disabled="isToggling[data.item.teacherId]"
          :class="data.value ? 'toggle-green' : 'toggle-red'"
        >
          &nbsp;
        </b-form-checkbox>
        <span v-else>
          <span v-if="data.value">
            <i class="fa fa-check-circle text-success" title="Yes" />
          </span>
          <span v-else>
            <i class="fa fa-times-circle text-danger" title="No" />
          </span>
        </span>
      </template>
      <template v-slot:cell(licensed)="data">
        <div class="d-inline">
          <span class="fa fa-check-circle" :class="{'text-success': data.value, 'text-secondary': !data.value}" />
        </div>
      </template>
      <template v-slot:cell(noIntensiveSupport)="data">
        <b-form-checkbox
          v-if="!isCertified"
          :checked="data.value"
          switch
          @change="onNoIntensiveSupportToggle(data.item, $event)"
          :disabled="isTogglingNoSupport[data.item.teacherId]"
          :class="data.value ? 'toggle-green' : 'toggle-red'">
          &nbsp;
        </b-form-checkbox>
        <span v-else>
          <span v-if="data.value">
            <i class="fa fa-check-circle text-success" title="Yes" />
          </span>
          <span v-else>
            <i class="fa fa-times-circle text-danger" title="No" />
          </span>
        </span>
      </template>
    </paginated-table>
  </div>
</template>

<script>
import PaginatedTable from '@/components/PaginatedTable.vue'
import LeaTooltip from '@/components/LeaTooltip.vue'
import AelsCaseIdLink from '@/components/AelsCaseIdLink.vue';
import CustomTooltip from '@/components/CustomTooltip.vue';
import { LeaTypes } from '@/helpers/leaTypes';
import { mapState } from 'vuex';

export default {
  components: {
    PaginatedTable,
    LeaTooltip,
    AelsCaseIdLink,
    CustomTooltip
  },
  props: {
    certificationStatus: {
      type: Object,
      required: false
    }
  },
  computed: {
    ...mapState('tgsModule', ['fiscalYear', 'subject', 'teacherMeritPays']),
    fields() {
      const leaFields = [];
      if (this.selectedLea.type > LeaTypes.District) {
        leaFields.push({ key: 'districtLEA', label: 'District', sortable: true });
      }
      if (this.selectedLea.type > LeaTypes.School) {
        leaFields.push({ key: 'schoolLEA', label: 'School', sortable: true });
      }

      return [
        ...leaFields,
        { key: 'teacherLastName', label: 'Last Name', sortable: true },
        { key: 'teacherFirstName', label: 'First Name', sortable: true },
        { key: 'caseId', label: 'Case ID', sortable: true },
        // { key: 'licensed', label: 'Licensed', sortable: true },
        // { key: 'tessRating', label: 'TESS Rating', sortable: true },
        // { key: 'threeYearCompositeGrowthScore', label: '3-Year Composite Growth Score', sortable: true },
        // { key: 'positiveImpactOnStudentGrowth', label: 'Positive Impact on Student Growth', sortable: true },
        { key: 'outstandingGrowthBonus', label: 'Overall Outstanding Growth Score Bonus', sortable: true, thClass: 'light-blue-header' },
        { key: 'overallShortageAreaBonus', label: 'Overall Shortage Area Bonus', sortable: true, thClass: 'light-orange-header' },
        { key: 'mentorBonus', label: 'Mentor Bonus', sortable: true, thClass: 'light-purple-header' },
        { key: 'totalBonus', label: 'Total Bonus', sortable: true },
        { key: 'meetsDefinitionOfTeacher', label: 'Meets Definition of Teacher', sortable: true },
        { key: 'noIntensiveSupport', label: 'Did Not Receive Intensive Support', sortable: true },
      ];
    },
    teachers() {
      let t = this.teacherMeritPays

      if (this.lastNameFilter && this.lastNameFilter.length > 0) {
        t = t.filter(e => e.teacherLastName.toLowerCase().includes(this.lastNameFilter.toLowerCase()))
      }
      if (this.firstNameFilter && this.firstNameFilter.length > 0) {
        t = t.filter(e => e.teacherFirstName.toLowerCase().includes(this.firstNameFilter.toLowerCase()))
      }

      return t
    },
    isCertified() {
      if (this.certificationStatus && this.certificationStatus.lastUpdatedBy) {
        return true;
      }
      return false;
    },
    // // Add computed property for query params to pass to pdf-button
    // queryParams() {
    //   return `&role=${this.selectedRole}&subject=${this.$store.state.tgsModule.subject || 'Composite'}`;
    // }
  },
  data() {
    return {
      selectedRole: this.$route.query.role || 'All',
      selectedType: 'All',
      lastNameFilter: '',
      firstNameFilter: '',
      topQuartileFilter: 'All',
      isToggling: {}, // Track toggling state per teacher for meetsDefinitionOfTeacher
      isTogglingNoSupport: {}, // Track toggling state per teacher for noIntensiveSupport
    }
  },
  watch: {
    selectedLea: {
      immediate: true,
      handler() {
        this.getTeacherMeritPays()
      }
    },
    fiscalYear: {
      immediate: true,
      handler() {
        this.getTeacherMeritPays()
      }
    },
  },
  methods: {
    goToLea(leaNumber) {
      const lea = this.$store.getters['globalModule/leaDictionary'][leaNumber]
      window.scrollTo(0, 0)
      this.$store.dispatch('globalModule/changeSelectedLea', lea)
    },
    getTeacherMeritPays() {
      if (this.selectedLea) {
        this.$store.dispatch('tgsModule/getTeacherMeritPays', { fiscalYear: this.fiscalYear, lea: this.selectedLea.number })
      }
    },
    async onMeetsDefinitionToggle(teacher, newValue) {
      const fiscalYear = this.fiscalYear;
      const lea = teacher.districtLEA || teacher.schoolLEA || (this.selectedLea && this.selectedLea.number);
      const teacherId = teacher.teacherId || teacher.caseId;
      if (!fiscalYear || !lea || !teacherId) return;
      this.$set(this.isToggling, teacherId, true);
      const url = `/api/merit-incentive/${fiscalYear}/${lea}/teachers/${teacherId}/teacherStatus?isTeacher=${newValue}`;
      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
        });
        if (!res.ok) throw new Error('Failed to update');
        teacher.meetsDefinitionOfTeacher = newValue;
      } catch (e) {
        // Optionally show error
        console.error('Error updating meetsDefinitionOfTeacher:', e);
      } finally {
        this.$set(this.isToggling, teacherId, false);
      }
    },
    async onNoIntensiveSupportToggle(teacher, newValue) {
      const fiscalYear = this.fiscalYear;
      const lea = teacher.districtLEA || teacher.schoolLEA || (this.selectedLea && this.selectedLea.number);
      const teacherId = teacher.teacherId || teacher.caseId;
      if (!fiscalYear || !lea || !teacherId) return;
      this.$set(this.isTogglingNoSupport, teacherId, true);
      const url = `/api/merit-incentive/${fiscalYear}/${lea}/teachers/${teacherId}/supportStatus?noIntensiveSupport=${newValue}`;
      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
        });
        if (!res.ok) throw new Error('Failed to update');
        teacher.noIntensiveSupport = newValue;
      } catch (e) {
        // Optionally show error
        console.error('Error updating noIntensiveSupport:', e);
      } finally {
        this.$set(this.isTogglingNoSupport, teacherId, false);
      }
    },
    excelExportData() {
      return {
        name: 'Teacher Merit Pay',
        items: this.teachers.map(e => {
          return {
            'District LEA': e.districtLEA,
            'School LEA': e.schoolLEA,
            'Teacher Last Name': e.teacherLastName,
            'Teacher First Name': e.teacherFirstName,
            'Case ID': e.caseId,
            // 'Licensed': e.licensed,
            // 'TESS Rating': e.tessRating,
            // '3-Year Composite Growth Score': e.threeYearCompositeGrowthScore,
            // 'Positive Impact on Student Growth': e.positiveImpactOnStudentGrowth,
            'Overall Outstanding Growth Score Bonus': e.outstandingGrowthBonus,
            'Overall Shortage Area Bonus': e.overallShortageAreaBonus,
            'Mentor Bonus': e.mentorBonus,
            'Total Bonus': e.totalBonus,
            'Meets Definition of Teacher': e.meetsDefinitionOfTeacher,
            'Did Not Receive Intensive Support': e.noIntensiveSupport,
          }
        })
      }
    }
  },
}
</script>

<style>
  .light-blue-header {
    background-color: #bbdefb !important;
    font-weight: bold;
  }
  .light-orange-header {
    background-color: #ffe0b2 !important;
    font-weight: bold;
  }
  .light-purple-header {
    background-color: #e1bee7 !important;
    font-weight: bold;
  }
  .toggle-green .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #28a745 !important;
    border-color: #28a745 !important;
  }
  .toggle-red .custom-control-input ~ .custom-control-label::before {
    background-color: #dc3545 !important;
    border-color: #dc3545 !important;
  }
  .toggle-green .custom-control-input ~ .custom-control-label::before {
    background-color: #28a745 !important;
    border-color: #28a745 !important;
  }
</style>
